import { ChangeDate } from './ChangeDate';
import setTimer from './set-timer';
import setTimerBanner from './set-timer-banner';

const initChangeDate = () => {  
  new ChangeDate({
    timer: true,
    start: "2024-12-10",
    end: '2025-03-28',
    period: 5
  }, setTimer);
  new ChangeDate({
    timer: true,
    start: "2024-12-10",
    end: '2025-01-31',
    period: 5
  }, setTimerBanner);
};

export default initChangeDate;
